import { Box, Typography } from 'bonfire-kindling';

const TimeRemaining = ({ value, label, isViewed }) => {
  return (
    <Box>
      <div
        style={{
          border: '1px solid #D8D8D8',
          height: '40px',
          width: '40px',
          borderRadius: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
          whiteSpace: 'pre',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            backgroundColor: theme => (isViewed ? '#EBEDF4' : theme.palette.common.white),
          }}
        >
          {value}
        </Typography>
      </div>
      <Typography variant="body3" sx={{ whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    </Box>
  );
};
export default TimeRemaining;
